export default {
  namespaced: true,
  state: {
    initialized: false,
    user: null
  },
  getters: {
    user: state => state.user
  },
  mutations: {
    setUser (state, user) {
      state.user = user
    },
    clearUser (state) {
      state.user = null
    },
    setInitialized (state) {
      state.initialized = true
    }
  },
  actions: {
    setUser: ({ commit }, user) => {
      // console.log('auth:setUser', user)
      commit('setUser', user)
    },
    clearUser: ({ commit }) => {
      // console.log('auth:clearUser')
      commit('clearUser')
    },
    initialized: ({ commit }) => {
      // console.log('auth:setInitialized')
      commit('setInitialized', true)
    }
  }
}
